import * as React from "react";
import { IconProps } from "./IconProps";

export const IconArrowRight = React.forwardRef<SVGSVGElement, IconProps>(
  ({ color = "currentColor", ...props }, forwardedRef) => {
    return (
      <svg
        width="12"
        height="12"
        viewBox="0 0 10 18"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
        ref={forwardedRef}
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M0.292892 0.292894C0.683416 -0.0976307 1.31658 -0.0976314 1.70711 0.292892L9.70711 8.29287C9.89464 8.48041 10 8.73476 10 8.99998C10 9.2652 9.89464 9.51955 9.70711 9.70709L1.70711 17.7071C1.31658 18.0976 0.683419 18.0976 0.292894 17.7071C-0.0976307 17.3166 -0.0976314 16.6834 0.292892 16.2929L7.58579 8.99998L0.292894 1.70711C-0.0976307 1.31658 -0.0976314 0.683419 0.292892 0.292894Z"
          fill={color}
        />
      </svg>
    );
  }
);
